import { memo } from 'react';
import cn from 'classnames';
import { Image, LazyloadImage } from 'src/components';
import { NativeVideo } from 'src/components/video';
import Card from 'src/components/card';

import styles from './styles.module.scss';
interface IProps {
    title: string;
    src: string;
    lazyload?: boolean;
    thumbIsGif?: boolean;
    CardImageClass?: string;
    CardFigureClass?: string;
    CardVideoClass?: string;
}

export function ContentThumb({
    title,
    src = '',
    lazyload = false,
    thumbIsGif = false,
    CardImageClass = '',
    CardFigureClass = '',
    CardVideoClass = '',
}: IProps) {
    if (thumbIsGif && false) {
        return (
            <Card.Image
                className={cn({ [styles['no-image']]: !src }, CardImageClass)}
            >
                <NativeVideo
                    className={cn(CardVideoClass)}
                    src={src}
                    lazyload={lazyload}
                />
            </Card.Image>
        );
    }

    const classImg = src
        ? ''
        : cn(
              'absolute',
              'flex items-center justify-center',
              'bg-[#e9ecef]',
              'transition-transform',
              'border border-solid border-[#dee2e6]',
              "before:content-['KHÔNG_CÓ_ẢNH']",
              'before:text-[var(--dark)] before:text-[1rem] before:text-center'
          );

    return (
        <Card.Image
            className={cn({ [styles['no-image']]: !src }, CardImageClass)}
        >
            {lazyload ? (
                <LazyloadImage
                    className={cn(CardFigureClass, classImg)}
                    src={src}
                    alt={title}
                />
            ) : (
                <Image
                    className={cn(CardFigureClass, classImg)}
                    src={src}
                    alt={title}
                />
            )}
        </Card.Image>
    );
}

export default memo(ContentThumb);
